'use es6';

import { APPLICATION_SET_ACTIVE_EDITOR, APPLICATION_TOGGLE_FINDER, APPLICATION_SET_IS_KEYBOARD_SHORTCUTS_LISTING_SHOWING, APPLICATION_HIDE_GLOBAL_CONTENT_MESSAGE, APPLICATION_SHOW_GLOBAL_CONTENT_MESSAGE, APPLICATION_SET_FINDER_WIDTH, APPLICATION_SET_ALWAYS_SHOW_FINDER_ON_START, APPLICATION_UPDATE_PREVIEWER, APPLICATION_EDITOR_LOADED, APPLICATION_DISMISS_SHOW_LOADING_WARNING, APPLICATION_DISMISS_RESPONSIVE_IMAGE_WARNING, APPLICATION_DISMISS_ICON_SET_WARNING, APPLICATION_DISMISS_ADVANCED_REL_WARNING, APPLICATION_DISMISS_ADVANCED_VIDEO_OPTIONS_WARNING, APPLICATION_ADD_PINNED_TAB, APPLICATION_REMOVE_PINNED_TAB } from 'DesignData/actions/ActionTypes';
import EditorOptions from 'DesignData/models/app/EditorOptions';
import { getUserSettings } from 'DesignData/selectors/userSettings';
import { getActiveAssetId } from 'DesignData/selectors/app';
import { isBoolean } from 'underscore';
/**
 * Set data needed to identify the active editor type and resource.
 *
 * @param {DesignAssetTypes}      assetType
 * @param {(String|Number|Null)}  assetId
 * @param {EditorOptions|Object}  editorOptions
 */

export function setActiveEditor(assetType, assetId = null, editorOptions = null) {
  editorOptions = editorOptions instanceof EditorOptions ? editorOptions : new EditorOptions(editorOptions || {});
  return (dispatch, getState) => {
    const state = getState();
    const previousAssetId = getActiveAssetId(state);
    dispatch({
      type: APPLICATION_SET_ACTIVE_EDITOR,
      assetType,
      assetId,
      editorOptions,
      previousAssetId
    });
  };
}
/**
 * Set whether or not finder is open
 *
 * @param {Boolean} isShowing
 */

export function toggleFinder(isShowing) {
  return {
    type: APPLICATION_TOGGLE_FINDER,
    isShowing
  };
}
/**
 * Set whether or not keyboard shortcuts listing is open
 *
 * @param {Boolean} isShowing
 */

export function setIsKeyboardShortcutsListingShowing(isShowing) {
  return {
    type: APPLICATION_SET_IS_KEYBOARD_SHORTCUTS_LISTING_SHOWING,
    isShowing
  };
}
/**
 * Show/hide global content onboarding message.
 */

export function showGlobalContentMessage() {
  return (dispatch, getState) => {
    const state = getState();
    const settings = getUserSettings(state);
    dispatch({
      type: APPLICATION_SHOW_GLOBAL_CONTENT_MESSAGE,
      show: settings.showGlobalContentMessage !== false
    });
  };
}
export function hideGlobalContentMessage() {
  return {
    type: APPLICATION_HIDE_GLOBAL_CONTENT_MESSAGE
  };
}
/**
 * Set finder width
 *
 * @param (String) width
 */

export function setFinderWidth(width) {
  return {
    type: APPLICATION_SET_FINDER_WIDTH,
    width
  };
}
/**
 * Set option to always show finder when starting up the Design Manager.
 *
 * @param {Boolean} alwaysShowFinderOnStartup
 * @throws {TypeError} If alwaysShowFinderOnStartup is not a Boolean
 */

export function setAlwaysShowFinderOnStartup(alwaysShowFinderOnStartup) {
  if (!isBoolean(alwaysShowFinderOnStartup)) {
    throw new TypeError(`setAlwaysShowFinderOnStartup() param must be a bool, received ${alwaysShowFinderOnStartup}`);
  }

  return {
    type: APPLICATION_SET_ALWAYS_SHOW_FINDER_ON_START,
    alwaysShowFinderOnStartup
  };
}
/**
 * Set option to update the previewer when switching files
 *
 * @param {Boolean} updatePreviewer
 * @throws {TypeError} If updatePreviewer is not a Boolean
 */

export function setUpdatePreviewer(updatePreviewer) {
  if (!isBoolean(updatePreviewer)) {
    throw new TypeError(`setAlwaysShowFinderOnStartup() param must be a bool, received ${updatePreviewer}`);
  }

  return {
    type: APPLICATION_UPDATE_PREVIEWER,
    updatePreviewer
  };
}
export function editorLoaded(fileId) {
  return {
    type: APPLICATION_EDITOR_LOADED,
    fileId
  };
}
export function dismissResponsiveImageWarning() {
  return {
    type: APPLICATION_DISMISS_RESPONSIVE_IMAGE_WARNING
  };
}
export function dismissShowLoadingWarning() {
  return {
    type: APPLICATION_DISMISS_SHOW_LOADING_WARNING
  };
}
export function dismissIconSetWarning() {
  return {
    type: APPLICATION_DISMISS_ICON_SET_WARNING
  };
}
export function dismissAdvancedRelOptionsWarning() {
  return {
    type: APPLICATION_DISMISS_ADVANCED_REL_WARNING
  };
}
export function dismissAdvancedVideoOptionsWarning() {
  return {
    type: APPLICATION_DISMISS_ADVANCED_VIDEO_OPTIONS_WARNING
  };
}
export function addPinnedTab(pinnedTabId) {
  return {
    type: APPLICATION_ADD_PINNED_TAB,
    pinnedTabId
  };
}
export function removePinnedTab(pinnedTabId) {
  return {
    type: APPLICATION_REMOVE_PINNED_TAB,
    pinnedTabId
  };
}